import { computeMasterDataHost } from '../store/actions/masterData/masterData.action';
import { config } from '../utils/constants/api.constants';

export default (api) => {
  const getLocations = (params) => {
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.storeLocation;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getCities = (params) => {
    const url =
      computeMasterDataHost() +
      config.api.masterdata.api_v2 +
      config.api.masterdata.masterData +
      config.api.masterdata.city;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLocationAuditLogs = (locationId, params) => {
    const url = `${computeMasterDataHost()}${config.api.masterdata.api}${
      config.api.masterdata.auditLog
    }${config.api.masterdata.storeLocation}/${locationId}`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getLocationAuditLogsCount = (locationId, params) => {
    const url = `${computeMasterDataHost()}${config.api.masterdata.api}${
      config.api.masterdata.auditLog
    }${config.api.masterdata.storeLocation}/${locationId}${
      config.api.masterdata.count
    }`;
    return new Promise((resolve, reject) => {
      api
        .get(url, params)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const getVideoPresignedUrl = (fileName, extension, mediaType, hubCode) => {
    const url = `${computeMasterDataHost()}${config.api.masterdata.api_v2}${
      config.api.masterdata.preSignedURL
    }?fileName=${fileName}&extension=${extension}&mediaType=${mediaType}&hubCode=${hubCode}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };
  const putVideoPresignedUrl = async (url, file) => {
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
      },
      body: file,
    });
    if (!res.ok) throw new Error('Upload failed');
    return true;
  };

  const getImagesPresignedUrl = (fileName, extension, mediaType, hubCode) => {
    const url = `${computeMasterDataHost()}${config.api.masterdata.api_v2}${
      config.api.masterdata.preSignedURLImage
    }?fileName=${fileName}&extension=${extension}&mediaType=${mediaType}&hubCode=${hubCode}`;
    return new Promise((resolve, reject) => {
      api
        .get(url)
        .then((response) => {
          resolve(response.data);
        })
        .catch((error) => {
          reject(error);
        });
    });
  };

  const putImagesPresignedUrl = async (url, file) => {
    const res = await fetch(url, {
      method: 'PUT',
      headers: {
        'Content-Type': file.type,
      },
      body: file,
    });
    if (!res.ok) throw new Error('Upload failed');
    return true;
  };

  return {
    getLocations,
    getImagesPresignedUrl,
    putImagesPresignedUrl,
    putVideoPresignedUrl,
    getCities,
    getLocationAuditLogs,
    getLocationAuditLogsCount,
    getVideoPresignedUrl,
  };
};
const FILE_VERSION = process.env.REACT_APP_FILE_VERSION;
